import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from './login.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { DialogConfirmComponent } from 'src/app/components/dialogs/dialog-confirm/dialog-confirm.component';
import { ChristmasService } from 'src/app/services/christmas.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

  userForm: UntypedFormGroup;
  submitted = false;
  isProgress: boolean = false;
  hidePassword: boolean = true;
  isChristmasMode: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginService,
    private router: Router,
    private snackBar: SnackBarService,
    private dialog: MatDialog,
    private christmasService: ChristmasService
  ) { }

  ngOnInit() {
    this.userForm = this.formBuilder.group({
      login: ['', [Validators.required, Validators.minLength(11), Validators.maxLength(11)]],
      password: ['', [Validators.required]]
    });
    this.isChristmasMode = this.christmasService.isChristmasMode();
  }

  // convenience getter for easy access to form fields
  get formControls() { return this.userForm.controls; }

  async onSubmit() {
    if (this.userForm.valid) {
      this.isProgress = true;

      try {
        const ret: any = await this.loginService.autenticar(this.userForm.value.login, this.userForm.value.password);

        if (!ret?.modulos?.length) {
          this.isProgress = false;
          this.router.navigate(['/usuario-sem-modulos']);
          return;
        }

        this.setDadosUsuario(ret);
        this.setModulos(ret);
        this.setTokenUser(ret);
        this.isProgress = false;
        this.snackBar.showSnackBarSuccess('usuário autenticado');
        this.router.navigateByUrl('/modulos');

      } catch (error) {
        this.isProgress = false;

        if (error.status === 423 && error.error.reativacao_necessaria) {
          this.router.navigate(['/usuario-inativo'], {
            state: {
              dadosInativacao: {
                ...error.error,
                login: this.userForm.value.login
              }
            }
          });
          return;
        }

        if (error.status === 403 && error.error?.sem_modulos) {
          this.router.navigate(['/usuario-sem-modulos']);
          return;
        }

        if (error.status === 401 && error.error?.atencao === 'Usuário com cadastro inativo') {
          this.router.navigate(['/usuario-sem-modulos']);
          return;
        }

        if (error.error?.error === 'Nao cadastrado') {
          this.snackBar.showSnackBarError('Usuário ou senha incorreto');
        } else if (error.error?.error === 'Não autorizado') {
          this.snackBar.showSnackBarError('Usuário ou senha incorreto');
        } else if (error.error?.error === 'Usuário inativo. Contate o administrador.') {
          this.snackBar.showSnackBarError('Sua conta está inativa. Entre em contato com o administrador do sistema.');
        } else {
          this.snackBar.showSnackBarError('Sistema indisponível. Tente novamente mais tarde.');
        }
      }
    }
  }

  setDadosUsuario(data) {
    localStorage.setItem('user', JSON.stringify(data.modulos[0]));
  }

  setModulos(data) {
    let mods: any = [];
    data.modulos.forEach(element => {
      mods.push({
        "id_modulo": element.id_modulo,
        "desc_modulo": element.desc_modulo,
        "sigla": element.sigla
      })
    });
    localStorage.setItem('modulos', JSON.stringify(mods));
  }

  setTokenUser(data) {
    localStorage.setItem('token', JSON.stringify(data.token));
  }

  reenviarSenha() {
    if (this.userForm.controls.login.valid) {
      const cpfDigitado = this.userForm.controls.login.value;

      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        width: '480px',
        data: {
          title: 'Confirmação',
          msg: 'Deseja realmente reenviar a senha para o CPF informado?',
          confirmLabel: 'Sim',
          dismissLabel: 'Não',
        }
      });

      dialogRef.afterClosed().toPromise().then((confirmed) => {
        if (confirmed) {
          this.isProgress = true;
          this.loginService.reenviarSenha(cpfDigitado)
            .then(ret => {
              this.snackBar.showSnackBarInfo(ret.toString())
              this.isProgress = false;
            })
            .catch(err => {
              this.snackBar.showSnackBarError(err.error.error);
              this.isProgress = false;
            });
        }
      });
    }
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  acessarConta() {
    console.log('Acessar conta clicado');
  }

}
